import React, { useEffect } from "react";
import InnerPopup from "./InnerPopup";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { withTranslation } from "react-i18next";
import UseBodyScrollLock from "./UseBodyScrollLock";

const ConfirmBetDeskonPopup = (props) => {
  const { onClose, message, mainContent } = props;
  const showModal = true;
  const callProcessSubmit = () => {
    props.submitProcessOk();
  };
  UseBodyScrollLock(showModal);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault(); 
        callProcessSubmit();
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [callProcessSubmit]);

  return (
    <>
      {showModal && (
        <div className="confirmation_modal">
          <InnerPopup onCloseModal={onClose}>
            <div className="betdiskon_poupcontent">
              <div className="confirm_img_conatiner">
                <IoIosInformationCircleOutline />
              </div>
              <h3>{ mainContent ? mainContent : (props.t("process_bet"))} ?</h3>
              <p>{message ? message : ""}</p>
              <div className="confirm_poupcontent_btns">
                <button className="btn" onClick={onClose}>
                  {props.t("no")}
                </button>
                <button className="btn" onClick={callProcessSubmit}>
                  {props.t("yes")}
                </button>
              </div>
            </div>
          </InnerPopup>
        </div>
      )}
    </>
  );
};

export default withTranslation()(ConfirmBetDeskonPopup);
